/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import mbpLogger from '@module-logger/mbp';
import { useQuery } from '@apollo/client';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { GRAPHQL_ENV } from '../../../gql';
import findContent from '../../../gql/queries/findContent';
import Subscription from './Subscription';
import { isEmpty } from '../../../pages/Account/utils/object';
import SubscriptionGenericLoader from './ProductsGenericLoader';
import { getBrandName } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import { getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getOrderId, getOrderStatus } from '../../../../state/ducks/Common/Common-Selectors';
import { getCart } from '../../../../state/ducks/Cart/Cart-Actions';

const SubscriptionGraphqlContainer = () => {
    const { pathname } = useLocation();
    const brandName = useSelector(getBrandName);
    const featureFlags = useSelector(getFeatureFlags);
    const orderId = useSelector(getOrderId);
    const orderStatus = useSelector(getOrderStatus);
    const dispatch = useDispatch();

    if (!featureFlags['is-subscription-exp-enabled']) return null;

    // retreiving cart data to check passport in the cart
    useEffect(() => {
        if (!orderStatus && orderId) {
            dispatch(getCart(orderId));
        }
    }, []);

    const FETCH_CMS_DATA = findContent({
        brand: brandName,
        contentType: 'subscriptions_lander',
        GRAPHQL_ENV,
    });
    const { loading, error, data } = useQuery(FETCH_CMS_DATA);
    if (loading && !data && !error) {
        return <SubscriptionGenericLoader />;
    }

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: FETCH_CMS_DATA,
            component: 'SubscriptionPage.js',
            message: 'Error loading CMS data for subscriptions exp page',
            env: GRAPHQL_ENV,
            error,
        });
        return null;
    }

    if (!data?.findContent?.content?.entries?.[0] && isEmpty(data?.findContent?.content?.entries?.[0])) return null;

    const subscriptionData = data?.findContent?.content?.entries?.[0] || {};
    const showBreadcrumbs = data?.findContent?.content?.entries?.[0]?.seo?.breadcrumb?.length > 0;
    const disclaimerData = data?.findContent?.content?.entries?.[0]?.disclaimer || '';
    const seoData = data?.findContent?.content?.entries?.[0]?.seo;
    const breadCrumb = seoData?.breadcrumb;

    let SEO = {};
    if (typeof seoData !== 'undefined') {
        SEO = JSON.parse(JSON.stringify(seoData));
    }
    SEO.og = [];
    SEO.og.push(
        { property: 'og:title', content: seoData?.page_title || '' },
        { property: 'og:type', content: 'website' },
        { property: 'og:description', content: seoData?.meta_description || '' },
        { property: 'og:url', content: `https://www.${brandName}.com${pathname || ''}` },
    );

    return (
        <>
            {seoData ? <GraphqlSeoHeadTags seoData={SEO} /> : null}
            <Subscription
                breadCrumb={breadCrumb}
                brand={brandName}
                disclaimerData={disclaimerData}
                showBreadcrumbs={showBreadcrumbs}
                subscriptionData={subscriptionData}
                pathname={pathname}
            />
        </>
    );
};

export default SubscriptionGraphqlContainer;
